/*eslint-disable*/
export default {
    data () {
        return {
            defaultCombiningDigitCapacities: [1, 2, 3, 4, 5, 6, 7, 8],
            combiningDigitCapacityLabels: {
                1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                8: this.$i18n.t('common.common_gameSetting_digitCapacity8')
            },
            difficultKeys: {
                'Однозначные цифры': 1,
                'Двузначные цифры': 2,
                'Трехзначные цифры': 3,
                'Четырехзначные цифры': 4,
                'Пятизначные цифры': 5,
                'Шестизначные цифры': 6,
                'Семизначные цифры': 7,
                'Восьмизначные цифры': 8
            }
        }
    },
    computed: {
        filteredCombiningDigitCapacities () {
            return this.defaultCombiningDigitCapacities.filter(
                capacity => capacity <= this.capacitiesLength
            );
        },
        capacitiesLength () {
            return typeof this.params.difficult === 'number' ? this.params.difficult : this.difficultKeys[this.params.difficult];
        }
    },
    methods: {
        changeCombiningDigitCapacities(combiningDigitCapacity) {
            if (this.params.combiningDigitCapacities.includes(combiningDigitCapacity)) {
                this.removeCombiningDigitCapacity(combiningDigitCapacity);
            } else {
                this.addCombiningDigitCapacity(combiningDigitCapacity);
            }
        },
        addCombiningDigitCapacity (combiningDigitCapacity) {
            this.params.combiningDigitCapacities.push(combiningDigitCapacity);
        },
        removeCombiningDigitCapacity(combiningDigitCapacity) {
            this.params.combiningDigitCapacities.splice(
                this.params.combiningDigitCapacities.indexOf(combiningDigitCapacity),
                1
            );
        },
        fillCombiningDigitCapacities() {
            let combiningDigitCapacities = [
                ...Array(this.capacitiesLength + 1).keys()
            ];
            combiningDigitCapacities.shift();
            this.params.combiningDigitCapacities = combiningDigitCapacities;
        }
    }
}
